import { ENV } from "../Utils/constants";

/**
 * Cliente API para el flujo 2FA del panel administrador.
 * Cada método mapea 1:1 con un endpoint del backend.
 *
 * Importante: los tokens intermedios (pendingAdminToken, otpToken) NO se
 * persisten en localStorage — solo viven en memoria del componente.
 */
export class AdminAuth {
  baseApi = ENV.BASE_API;

  async fetchSuperAdmins(pendingAdminToken) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.ADMIN_SUPERUSERS}`;
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pendingAdminToken }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result.data ? result.data.superusers : [];
  }

  async sendOtp(pendingAdminToken, email) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.ADMIN_SEND_OTP}`;
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pendingAdminToken, email }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result.data ? result.data.otpToken : null;
  }

  async verifyOtp(otpToken, code) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.ADMIN_VERIFY_OTP}`;
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ otpToken, code }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return { access: result.access, refresh: result.refresh };
  }

  async resendOtp(otpToken) {
    const url = `${this.baseApi}/${ENV.API_ROUTES.ADMIN_RESEND_OTP}`;
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ otpToken }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
